exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shn-statistic[data-v-4220046c]{color:rgba(0,0,0,.65);line-height:1.5;list-style:none;font-variant:tabular-nums}", ""]);

// exports
